<template>
  <div
    :style="{ borderColor: theme.current.value.colors['on-surface'] }"
    class="d-flex align-center justify-center"
    style="width: 42px; height: 42px; border: solid 2px; opacity: 0.6"
  >
    <v-icon :icon="value ? mdiMinus : mdiPlus" size="26" />
  </div>
</template>

<script setup>
import { useTheme } from 'vuetify'
import { mdiMinus, mdiPlus } from '@mdi/js'

defineProps({
  value: {
    default: false,
    type: Boolean
  }
})

const theme = useTheme()
</script>
